<template functional>
  <div class="featured-content is-hidden-tablet">
    <h2 class="page-title">
      {{ props.featuredContentHeader }}
    </h2>
    <div class="columns">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturedContentList',

  props: {
    featuredContentHeader: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.featured-content {
  width: 100%;
  margin-bottom: 8px;
}
</style>
